/**
 * Returns true if a provider-practice bridge is currently visible/active:
 * - No endDate → always active
 * - endDate is in the future → active
 * - endDate is today or earlier but displayDate is today or in the future → active (grace period)
 * - Otherwise → inactive
 *
 * Date strings are compared as YYYY-MM-DD. Any time component (e.g. full ISO
 * timestamps from the backend) is stripped to the first 10 characters so that
 * same-day timestamps are never incorrectly treated as future dates.
 */
export function isActiveProviderBridge(
  bridge: { endDate?: string; displayDate?: string },
): boolean {
  if (!bridge.endDate) return true;
  const today = localDateStr();
  if (bridge.endDate.slice(0, 10) > today) return true;
  return !!(bridge.displayDate && bridge.displayDate.slice(0, 10) >= today);
}

/** Returns today's date as a YYYY-MM-DD string in the local timezone. */
function localDateStr(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
